import { TableProps } from 'antd';
import { SorterResult } from 'antd/es/table/interface';
import { useEffect, useState } from 'react';
import LogsTable from 'src/app/components/TableComponent/LogsTableComponent/LogsTable';
import { LogLookupDataType } from 'src/app/redux/logs/logs-slice.type';
import { useGetLogsInfiniteQuery } from 'src/app/redux/logs/logsSlice';
import { Log } from 'src/types/log.type';
import { useVT } from 'virtualizedtableforantd4';

const LIMIT = 50;
const TABLE_HEIGHT = 'calc(100vh - 21rem)';
const DEFAULT_FILTERS: LogLookupDataType = { offset: 0 };

const UserEvents = () => {
  const [filters, setFilters] = useState<LogLookupDataType>(DEFAULT_FILTERS);
  const [hasMore, setHasMore] = useState<boolean>(true);

  const { data: logs } = useGetLogsInfiniteQuery({ ...filters, limit: LIMIT }, { refetchOnMountOrArgChange: true });

  useEffect(() => {
    if (logs && logs.count === logs.rows.length) {
      setHasMore(false);
    } else setHasMore(true);
  }, [logs]);

  // Vt component to be able to trigger queries on scroll in antd table
  const [vt, ,] = useVT(
    () => ({
      onScroll: ({ isEnd, top }) => {
        if (isEnd && hasMore) {
          setFilters((prev: any) => ({ ...prev, offset: prev.offset + LIMIT }));
        }
      },
      scroll: {
        y: TABLE_HEIGHT,
      },
      offset: 40,
    }),
    [hasMore],
  );

  const onTableChange: TableProps['onChange'] = (_p, tableFilters, sorter) => {
    const sorterObj = sorter as SorterResult<Log>;
    const sortOrder = sorterObj.order === 'ascend' ? 'ASC' : sorterObj.order === 'descend' ? 'DESC' : undefined;
    const order = sorterObj.field as string | undefined;

    setFilters((prev) => ({
      ...prev,
      actors: (tableFilters.actor as string[]) || undefined,
      actions: (tableFilters.action as string[]) || undefined,
      order,
      sortOrder,
      offset: 0,
    }));
    setHasMore(true);
  };

  const onTableReset = () => {
    setFilters(DEFAULT_FILTERS);
    setHasMore(true);
  };

  return (
    <LogsTable
      filtersEnabled
      dataSource={logs?.rows || []}
      tableHeight={TABLE_HEIGHT}
      vt={vt}
      onTableChange={onTableChange}
      onTableReset={onTableReset}
    />
  );
};

export default UserEvents;
